import React from "react";
import { Icon } from "react-icons-kit";
import { navicon } from "react-icons-kit/fa/navicon";

const NavIcon = () => {
  return (
    <div style={{ color: "#edf2fb" }}>
      <Icon icon={navicon} size={36} />
    </div>
  );
};

export default NavIcon;
